import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import styled from 'styled-components';
import {
  StyledTable,
  StyledTitle,
  StyledTd,
} from './custom-styled-components/_MyCustomSC';
import { DatePicker } from 'antd';

const StyledDiv = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;
const dateFormat = 'DD MMM, YYYY';

/**
 * @component
 * @category Form Page
 * @subcategory Pickup
 * @name PickupDate
 * @description it's the pickup date picker
 * <br> <br>
 * **Example**
 * ```js
 *
 *<PickupDate  />
 * ```
 */
class PickupDate extends Component {
  componentDidMount = () => {
    const {
      pickup: { date },
    } = this.props;
    //if date is already set and valid in redux store then do not update it
    const isValidDate = moment(date, dateFormat, true).isValid();
    !isValidDate &&
      this.props.updatePickupData({
        date: moment(new Date()).format(dateFormat),
      });
  };

  /**
   * @description when a date is selected, this method gets fired
   * <br> <br>
   * **onDateChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | Object        | `moment` date object |

   * Returns: Type: void
   */
  onDateChange = (value) => {
    if (moment(value).format(dateFormat) !== 'Invalid date') {
      this.props.updatePickupData({ date: moment(value).format(dateFormat) });
    } else {
      this.props.updatePickupData({
        date: moment(new Date()).format(dateFormat),
      });
    }
  };

  render() {
    const {
      pickup: { date, pickupType },
      formDaysPast,
      formDaysFuture,
    } = this.props;

    const hideBottomDiv = pickupType === 'factory';

    return (
      <StyledDiv className="pickup-date my-form-calendar">
        <StyledTable style={{ width: '214px' }}>
          <tbody>
            <tr>
              <th>
                <div style={{ fontWeight: 600, marginLeft: '4px' }}>
                  Goods ready (Estimated)
                </div>
              </th>
            </tr>
            <tr>
              <StyledTd
                style={{
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-around',
                }}
              >
                <StyledTitle>Goods ready (estimated)</StyledTitle>
                <DatePicker
                  defaultValue={moment(date ? date : new Date(), dateFormat)}
                  defaultPickerValue={moment(
                    date ? date : new Date(),
                    dateFormat
                  )}
                  format={dateFormat}
                  allowClear={false}
                  onChange={this.onDateChange}
                  showToday={true}
                  disabledDate={(current) => {
                    let tempPastDays = Number(formDaysPast);
                    tempPastDays = isNaN(tempPastDays) ? 0 : tempPastDays;
                    tempPastDays = 1 + tempPastDays; //add Today
                    const currDate =
                      current &&
                      (current < moment().subtract(tempPastDays, 'day') ||
                        current > moment().add(formDaysFuture, 'day'));

                    return currDate;
                  }}
                />
                {!hideBottomDiv && <div style={{ height: '25px' }}></div>}
              </StyledTd>
            </tr>
          </tbody>
        </StyledTable>
      </StyledDiv>
    );
  }
}

PickupDate.propTypes = {
  /**
   * pickup section data
   */
  pickup: PropTypes.object,
  /**
   * DatePicker past dates limit on form page.
   */
  formDaysPast: PropTypes.number,
  /**
   *  DatePicker future dates limit on form page.
   */
  formDaysFuture: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    pickup: state.form.pickup,
    formDaysPast: state.code_config.formDaysPast,
    formDaysFuture: state.code_config.formDaysFuture,
  };
};

export default connect(mapStateToProps, actions)(PickupDate);
